/**
 * Cantidades numericas con un invariante **ya confirmado** por las reglas.
 *
 * Solo hay dos. No es un sistema de Value Objects: cada tipo de este fichero
 * existe porque `GAME_RULES.md` fija explicitamente su cota, y marcarlo impide
 * construir un estado que las reglas ya declaran ilegal.
 *
 * Deliberadamente **no** hay tipos equivalentes para `Poder`, `Vida` impresa,
 * `Alcance`, `Valor` de Ofrenda, tamano minimo del mazo, cantidad minima de
 * Ofrendas ni limite de copias: ninguna de esas cotas esta decidida, y
 * inventarla seria rellenar un pendiente por comodidad del tipado.
 */
function requireCount(value, label) {
    if (!Number.isInteger(value)) {
        throw new RangeError(`${label} debe ser un entero, y se recibio ${String(value)}.`);
    }
    if (value < 0) {
        throw new RangeError(`${label} no puede ser negativo, y se recibio ${String(value)}.`);
    }
    return value;
}
/**
 * Construye un coste valido.
 *
 * @throws {RangeError} Si `value` es negativo o no es entero.
 */
export function createCardCost(value) {
    return requireCount(value, 'El coste de una carta');
}
/**
 * Construye una reserva temporal valida.
 *
 * @throws {RangeError} Si `value` es negativo o no es entero.
 */
export function createTemporaryResource(value) {
    return requireCount(value, 'La reserva temporal de recurso');
}
/** Reserva vacia: el valor con el que empieza y termina toda Fase de Accion. */
export const NO_TEMPORARY_RESOURCE = createTemporaryResource(0);
//# sourceMappingURL=amounts.js.map